import {
    SeloPremiadoFornecedorActionsTypes,
    type SeloPremiadoFornecedorAction,
} from "./seloPremiadoFornecedorActions"
import {
    SeloPremiadoFornecedorInicial,
    NovoSeloFormInicial,
    type SeloPremiadoFornecedorModel,
} from "../models/seloPremiadoFornecedorModel"

const { CARREGAR, SET_BUSCA, ATUALIZAR_CAMPO_NOVO, RESETAR_FORM } = SeloPremiadoFornecedorActionsTypes

export function seloPremiadoFornecedorReducer(
    state: SeloPremiadoFornecedorModel = SeloPremiadoFornecedorInicial,
    action: SeloPremiadoFornecedorAction
): SeloPremiadoFornecedorModel {
    switch (action.type) {
        case CARREGAR:
            return { ...state, selos: action.payload }
        case SET_BUSCA:
            return { ...state, busca: action.payload }
        case ATUALIZAR_CAMPO_NOVO:
            return {
                ...state,
                novoSelo: { ...state.novoSelo, [action.payload.campo]: action.payload.valor },
            }
        case RESETAR_FORM:
            return { ...state, novoSelo: { ...NovoSeloFormInicial } }
        default:
            return state
    }
}
